import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25RequestedChangesComponent } from "../../standalone/s25.requested.changes.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25TableModule } from "../s25-table/s25.table.module";
import { S25RuleTreeModule } from "../s25-rule-tree/s25.rule.tree.module";
import { S25DndSortableModule } from "../s25-dnd-sortable/s25.dnd.sortable.module";
import { S25RichTextEditorModule } from "../s25-rich-text-editor/s25.rich.text.editor.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25PipesModule } from "../../pipes/s25.pipes.module";

import { AiFormWorkflowBuilderComponent } from "../../standalone/form-workflow-builder/ai.form.workflow.builder.component";
import { AiFormEditorComponent } from "../../standalone/form-workflow-builder/ai.form.editor.component";
import { IngestionDashboardComponent } from "./ingestion.dashboard.component";
import { IngestionFormTileComponent } from "./ingestion.form.tile.component";
import { IngestionFormComponent } from "./ingestion.form.component";
import { IngestionAdminFormComponent } from "./admin/ingestion.admin.form.component";
import { IngestionAdminComponent } from "./admin/ingestion.admin.component";
import { IngestionSubcategorySelectorComponent } from "./admin/ingestion.subcategory.selector.component";
import { IngestionSearchReportComponent } from "./ingestion.search.report.component";
import { IngestionSearchFormSelectorComponent } from "./ingestion.search.form.selector.component";
import { IngestionFieldSelectorComponent } from "./ingestion.field.selector.component";
import { IngestionAggregationSelectorComponent } from "./ingestion.aggregation.selector.component";
import { IngestionPredicateBuilderComponent } from "./ingestion.predicate.builder.component";
import { IngestionPredicateNodeComponent } from "./ingestion.predicate.node.component";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25ObjectOccurrenceFieldComponent } from "./field-types/s25.object.occurrence.field.component";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { LinkedFormsComponent } from "./linked-forms.component";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";
import { S25FadingSuccessMsgComponent } from "../s25-fading-success-msg/s25.fading.success.msg.component";
import { IngestionAdminRulesComponent } from "./admin/ingestion.admin.rules.component";
import { IngestionAdminAccessRulesComponent } from "./admin/ingestion.admin.access.rules.component";
import { IngestionAdminFormFieldsPaletteComponent } from "./admin/ingestion.admin.form.fields.palette.component";
import { IngestionAdminFormFieldsTabComponent } from "./admin/ingestion.admin.form.fields.tab.component";
import { IngestionAdminFormFieldCardComponent } from "./admin/ingestion.admin.form.field.card.component";
import { DurationFieldComponent } from "./field-types/s25.duration.field.component";
import { INGESTION_SECURITY_SERVICE } from "./ingestion.security.service";
import { RoleBasedIngestionSecurityService } from "./role.based.ingestion.security.service";
import { FillableFormsComponent } from "./fillable.forms.component";
import { S25SimpleCollapseModule } from "../s25-simple-collapse/s25.simple.collapse.module";
import { S25TriggerRerenderModule } from "../s25-trigger-rerender/s25.trigger.rerender.module";
import { WorkflowDiagramViewerComponent } from "../workflow/diagram/workflow.diagram.viewer.component";
import { WorkflowChatPanelComponent } from "../workflow/chat/workflow.chat.panel.component";
import { ApprovalGroupsStore } from "../approval-groups/approval.groups.store";
import { DraggableDirective } from "../s25-movable/s25.movable.element.directive";
import { S25FilestoreImageComponent } from "../../standalone/s25.filestore.image.component";
import { IngestionFormUseHelpComponent } from "./admin/ingestion.form.use.help.component";

@NgModule({
    declarations: [
        IngestionDashboardComponent,
        IngestionAdminFormComponent,
        IngestionAdminFormFieldsTabComponent,
        IngestionAdminFormFieldCardComponent,
        IngestionAdminComponent,
        IngestionAdminRulesComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
    ],
    imports: [
        IngestionSubcategorySelectorComponent,
        CommonModule,
        FormsModule,
        S25ButtonComponent,
        IngestionFormTileComponent,
        S25RequestedChangesComponent,
        S25ModalModule,
        S25ItemModule,
        S25CheckboxModule,
        S25TableModule,
        S25RuleTreeModule,
        S25DndSortableModule,
        S25RichTextEditorModule,
        S25DropdownPaginatedModule,
        S25PipesModule,
        S25EditableModule,
        S25ObjectOccurrenceFieldComponent,
        S25FadingSuccessMsgComponent,
        S25MultiselectModule,
        LinkedFormsComponent,
        IngestionFormComponent,
        FillableFormsComponent,
        S25IconComponent,
        S25IconButtonComponent,
        DurationFieldComponent,
        AiFormWorkflowBuilderComponent,
        AiFormEditorComponent,
        IngestionAdminAccessRulesComponent,
        IngestionAdminFormFieldsPaletteComponent,
        S25SimpleCollapseModule,
        S25TriggerRerenderModule,
        WorkflowDiagramViewerComponent,
        WorkflowChatPanelComponent,
        DraggableDirective,
        S25FilestoreImageComponent,
        IngestionFormUseHelpComponent,
    ],
    providers: [
        { provide: INGESTION_SECURITY_SERVICE, useClass: RoleBasedIngestionSecurityService },
        ApprovalGroupsStore,
        IngestionDashboardComponent,
        IngestionAdminFormComponent,
        IngestionAdminComponent,
        IngestionSubcategorySelectorComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
    ],
    exports: [
        IngestionDashboardComponent,
        IngestionFormComponent,
        IngestionAdminFormComponent,
        IngestionAdminComponent,
        IngestionSubcategorySelectorComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
    ],
})
export class DataIngestionModule {
    constructor() {}
}
